import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Breadcrumb } from 'primeng/breadcrumb';
import { NavigationStart, Router, RouterModule } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  items: any = [];

  home: any | undefined;
  userCred: any = []

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // FORCE CLEANUP of modal and backdrop on any navigation
        $('.modal').modal('hide'); // Hide any open modal
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $(document).on('hidden.bs.modal', '.modal', function () {
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
      });
  });

  setTimeout(() => {
    $(document).on('hidden.modal', '.modal', function () {
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();
    });
  });
}

  ngOnInit() {

    $('.modal').on('hidden.modal', function () {
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();
    });

    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);

    let activeUrl = location.pathname.split("/")
    let matches: any[] = [];

    let rolePrevilages = this.userCred?.rolePrevilages || [];
    for(var i = 0; i < rolePrevilages.length; i++){
      let screens = rolePrevilages[i]?.screenPrivilegeList || [];
      for(var j = 0; j < screens.length; j++) {
        if(screens[j]?.name == activeUrl[activeUrl.length-1]){
          matches.push({
            groupName: rolePrevilages[i]?.groupName,
            description: screens[j]?.description
          });
        }
      }
    }

    if (matches.length > 0) {
      let activeParent = sessionStorage.getItem('activeBreadcrumbParent');
      let bestMatch = matches.find(m => m.groupName === activeParent) || matches[0];
      
      this.items.push(
        { label: activeParent || bestMatch.groupName },
        { label: bestMatch.description }
      );
    }
  }
}
